import { Button, Dialog, DialogBody, DialogContent, DialogSurface, DialogTitle, mergeClasses, Text } from '@fluentui/react-components';
import { Dismiss24Regular } from '@fluentui/react-icons';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useCommonStyles } from '../../../common/hooks';
import './CountryEligibilityModal.scss';

interface CountryEligibilityModalProps {
  onCloseModal: () => void;
}

const CountryEligibilityModalImpl: React.FC<CountryEligibilityModalProps> = (props) => {
  const {
    onCloseModal,
  } = props;

  const commonStyles = useCommonStyles();
  return (
    <Dialog
      open
      onOpenChange={(_, data) => {
        if (!data.open) onCloseModal();
      }}
    >
      <DialogSurface
        className={mergeClasses(commonStyles.modalSurface, 'country-eligibility-modal')}
      >
        <DialogBody
          className={commonStyles.modalBody}
        >
          <DialogTitle
            action={
              <Button
                onClick={onCloseModal}
                appearance='subtle'
                aria-label='close'
                icon={<Dismiss24Regular />}
              />
            }
          >
            Country Partner of the Year eligibility
          </DialogTitle>

          <DialogContent>
            <Text
              as='p'
              weight='semibold'
            >
              Eligibility for a country’s Partner of the Year Award include:
            </Text>
            <ul>
              <li>
                Nominees must be a&nbsp;
                <a
                  href='https://partner.microsoft.com/en-us/partnership'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='link'
                >
                  Microsoft partner
                </a>
                &nbsp;member of the Microsoft AI Cloud Partner Program in good standing (members that have renewed, paid, etc.).
              </li>
              <li>
                Achievement of one of the following criteria by June 1, 2025:
                <ul className='sub-list-rules'>
                  <li>A Solutions Partner designation in any of the six solutions areas. </li>
                  <li>An IP Co-sell eligible solution <strong>and</strong> participation in Microsoft ISV offers.</li>
                  <li>At least 1 solution with certified software designation.</li>
                  <li>Training services partners:
                    enrollment in the Training Services Partner Program
                    and achieved Solutions Partner for Training Service designation.</li>
                  <li>Surface partners: Partner needs to be enrolled in the Surface Reseller Alliance program.</li>
                  <li>OEM device partners: Microsoft device partner including OEM (device manufacturer), Distributor, or Reseller.</li>
                </ul>
              </li>
            </ul>
          </DialogContent>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export const CountryEligibilityModal = observer(CountryEligibilityModalImpl);
